<template>
    <div>
        <div v-if="!toggler.isOpen()">
            <input class="form-control" @click="open" :placeholder="placeholder" readonly type="text" :value="value" />
        </div>
        <div class="{mt:8}@<md" v-else>
            <div class="input-group rel w:full">
                <input class="form-control" :class="{ error: mail.error }" @input="mail.error = false" inputmode="email" :placeholder="placeholder" ref="input" type="text" v-model.trim="mail.target" />
                <button class="btn btn-secondary w:90 opacity-50 fw-bold" type="button" v-if="mail.countdown">{{ toTimeString(mail.countdown) }}</button>
                <button class="btn btn-secondary w:120" :class="{ 'btn-danger': mail.error }" @click="send" type="button" v-else-if="mail.target">傳送驗證碼</button>
            </div>
            <div class="row mt:8!" v-if="mail.pending">
                <div class="col-12">
                    <div class="input-group">
                        <input class="form-control" :class="{ error: mail.code_error }" :id="`college-mail-code-${index}`" @input="mail.code_error = false" inputmode="numeric" placeholder="請輸入驗證碼5碼" type="text" v-model.trim="mail.code" />
                        <button class="btn btn-secondary w:120" :class="{ 'btn-danger': mail.code_error }" @click="verify" type="button" v-text="mail.code_error ? '驗證碼有誤' : '點我驗證'"></button>
                    </div>
                </div>
            </div>
            <div class="t:right mt:8 {ml:8}>button+button" v-if="closeable">
                <button class="btn btn-sm bg:#EEF3FB! color:#4776B4!" @click="toggler.close()" type="button">關閉</button>
            </div>
        </div>
    </div>
</template>

<script setup>
    let submited = false;

    const input = ref({});
    const mail = ref({});

    const props = defineProps({
        closeable: { default: true, type: Boolean },
        index: { required: true, type: Number },
        placeholder: { type: String },
        value: { default: "", type: String }
    });

    const toggler = ToggleStore().toggler(`college_mail_${props.index}`);

    const emit = defineEmits(["error", "send", "update"]);

    const open = () => {
        if (props.value) {
            return;
        }
        mail.value = { code: "", code_error: false, countdown: 0, error: false, input: `#college-mail-code-${props.index}`, pending: false, target: "", url: "api/member/send-verify-code" };
        toggler.open();
        setTimeout(() => input.value.focus());
    };

    const send = () => {
        emit("send", mail.value);
    };

    const toTimeString = (time) => {
        const m = parseInt(time / 60);
        const s = time % 60;
        return (100 + m).toString().substring(1) + ":" + (100 + s).toString().substring(1);
    };

    const verify = () => {
        if (submited) {
            return;
        }
        submited = true;
        api("api/member/verify-mail", { code: mail.value.code }, { prevent: true }).done((res) => {
            if (res.success) {
                emit("update", { index: props.index, college: res.college });
                toggler.close();
            } else {
                switch (res.error) {
                    case "error.verification-code-not-matched":
                        mail.value.code_error = true;
                        break;
                    default:
                        emit("error", res.message);
                }
            }
        }).always(() => {
            submited = false;
        });
    };
</script>
